import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

const rp = (n) => "Rp" + (n == null ? "0" : Math.round(n).toLocaleString("id-ID"));

function KPI({ label, value, sub, testid, tone }) {
  return (
    <Card data-testid={testid} className="p-4 bg-slate-900 border-slate-800">
      <div className="text-xs text-slate-400">{label}</div>
      <div className={`text-xl font-semibold mt-1 ${tone || "text-white"}`}>{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </Card>
  );
}

export default function FinanceDashboard() {
  const [period, setPeriod] = useState("month");
  const [d, setD] = useState(null);
  const load = async () => { try { setD((await api.get(`/finance/dashboard?period=${period}`)).data); } catch (e) { toast.error(apiError(e)); } };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [period]);
  if (!d) return <div className="p-6 text-slate-400">Memuat…</div>;
  const p = d.pnl;
  return (
    <div className="p-6" data-testid="finance-dashboard-page">
      <div className="flex justify-between items-center mb-4">
        <div><h1 className="text-2xl font-semibold text-white">Dashboard Keuangan</h1>
          <p className="text-slate-400 text-sm">Berbasis jurnal Posted · {d.period.from} s/d {d.period.to}</p></div>
        <div className="flex items-center gap-3">
          <span className={`text-xs px-2 py-1 rounded ${d.status === "FINAL" ? "bg-emerald-500/15 text-emerald-400" : "bg-amber-500/15 text-amber-400"}`}>{d.status}</span>
          <select value={period} onChange={(e) => setPeriod(e.target.value)} data-testid="fd-period" className="bg-slate-800 border border-slate-700 rounded px-3 py-2 text-sm text-white">
            {[["today", "Hari Ini"], ["month", "Bulan Ini"], ["last_month", "Bulan Sebelumnya"], ["year", "Tahun Ini"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <KPI testid="kpi-revenue" label="Pendapatan" value={rp(p.revenue)} />
        <KPI testid="kpi-cogs" label="HPP" value={rp(p.cogs)} />
        <KPI testid="kpi-gross" label="Laba Kotor" value={rp(p.gross_profit)} sub={`Margin ${p.gross_margin ?? "—"}%`} tone="text-emerald-400" />
        <KPI testid="kpi-net" label="Laba Bersih" value={rp(p.net_profit)} sub={`Margin ${p.net_margin ?? "—"}%`} tone="text-emerald-400" />
        <KPI testid="kpi-opex" label="Beban Operasional" value={rp(p.operating_expense)} />
        <KPI testid="kpi-cash" label="Total Kas & Bank" value={rp(d.cash_bank_total)} />
        <KPI testid="kpi-ar" label="Piutang (AR)" value={rp(d.ar.outstanding)} sub={`${d.ar.count} order`} />
        <KPI testid="kpi-ap" label="Hutang (AP)" value={rp(d.ap.outstanding)} sub={`${d.ap.count} tagihan`} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <KPI testid="kpi-waiting-hpp" label="Order Menunggu HPP" value={d.orders_waiting_hpp} tone={d.orders_waiting_hpp ? "text-amber-400" : "text-white"} />
        <Card data-testid="pending-posting" className="p-4 bg-slate-900 border-slate-800">
          <div className="text-xs text-slate-400 mb-1">Menunggu Posting (Draft)</div>
          <div className="text-xl font-semibold text-amber-400">{d.draft_pending.total_count} jurnal · {rp(d.draft_pending.total_value)}</div>
          <div className="text-xs text-slate-500 mt-2">{Object.entries(d.draft_pending.by_module || {}).map(([k, v]) => `${k}: ${v.count}`).join(" · ") || "Tidak ada"}</div>
          <div className="text-xs text-slate-600 mt-1">*Tidak dihitung dalam laporan resmi</div>
        </Card>
      </div>
    </div>
  );
}
